import { deriveAffectedUserLookup } from '@/features/AuditLogs/lib/affectedUserLookup'
import { useGetUsersByEmail } from '@/generated/http-clients/v2ApiComponents'

export function useAffectedUserLookup(email: string | null) {
  const query = useGetUsersByEmail(
    { queryParams: { email: email ?? '' } },
    { enabled: email !== null, retry: false },
  )
  return {
    lookup: deriveAffectedUserLookup(email, query),
    refetch: query.refetch,
  }
}
